<template>
  <div class="main-area">
    <div class="top-header">
      <h3>点餐收银台</h3>
      <div class="search-wrapper">
        <i class="fas fa-search" style="color:#ccc;"></i>
        <input type="text" placeholder="搜索..." v-model="searchValue" @input="handleSearch" />
      </div>
    </div>
    <div class="goods-grid">
      <div v-for="product in filteredProducts" :key="product.id" class="goods-card"
        @click="handleProductClick(product)">
        <div style="position:relative;">
          <img :src="product.coverPhoto" class="goods-img" @error="handleImageError" />
        </div>
        <div class="goods-info">
          <div class="goods-name">{{ product.name }}</div>
          <div class="goods-price">¥{{ product.price.toFixed(2) }}</div>
        </div>
      </div>
      <div v-if="filteredProducts.length === 0" class="empty-goods">
        暂无商品
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'MealGoodsGrid',
  props: {
    products: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      searchValue: ''
    }
  },
  computed: {
    filteredProducts() {
      let result = this.products

      // 按搜索关键词过滤
      if (this.searchValue) {
        const keyword = this.searchValue.toLowerCase()
        result = result.filter(p => p.name.toLowerCase().includes(keyword))
      }

      return result
    }
  },
  methods: {
    handleSearch() {
      this.$emit('search', this.searchValue)
    },
    handleProductClick(product) {
      this.$emit('product-click', product)
    },
    handleImageError(e) {
      e.target.style.display = 'none'
    }
  }
}
</script>

<style scoped>
.main-area {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 20px;
  overflow: hidden;
}

.top-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.top-header h3 {
  margin: 0;
  font-size: 20px;
  font-weight: 600;
  color: #2D3436;
}

.search-wrapper {
  background: #ffffff;
  border-radius: 50px;
  padding: 10px 20px;
  display: flex;
  align-items: center;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  width: 300px;
}

.search-wrapper input {
  border: none;
  outline: none;
  margin-left: 10px;
  width: 100%;
  font-size: 14px;
  background: transparent;
}

.goods-grid {
  flex: 1;
  overflow-y: auto;
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
  gap: 20px;
  padding-bottom: 20px;
  scrollbar-width: none;
}

.goods-grid::-webkit-scrollbar {
  display: none;
}

.goods-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  cursor: pointer;
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.05);
  position: relative;
  transition: transform 0.1s;
  display: flex;
  flex-direction: column;
  height: 260px;
}

.goods-card:active {
  transform: scale(0.98);
}

.goods-img {
  width: 100%;
  aspect-ratio: 1;
  object-fit: contain;
  background: #eee;
}

.goods-info {
  padding: 10px;
  text-align: center;
  flex-shrink: 0;
}

.goods-name {
  font-weight: 600;
  font-size: 15px;
  margin-bottom: 5px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.goods-price {
  color: #FF6B6B;
  font-weight: 800;
  font-size: 16px;
}

.empty-goods {
  grid-column: 1 / -1;
  text-align: center;
  margin-top: 50px;
  color: #ccc;
  font-size: 16px;
}
</style>
